import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';
import {
  ICreateXeroConnectionRequest,
  ICreateXeroConnectionResponse,
  IXeroTenantFeedResponse,
  IGetXeroTenantResponse,
  IRequestXeroConnectionResponse,
  ICreateXeroFeedRequest,
  ICreateXeroTenantConnectionResponse,
  IGetTenantByAccountIdResponse
} from './types/Xero';

export const requestXeroConnectionAuthUrl = async () =>
  api
    .post<IRequestXeroConnectionResponse, null>('api/v1/xero/request-connection', null)
    .then((response) => response)
    .catch(handleApiError);

export const createXeroConnection = async (requestBody: ICreateXeroConnectionRequest) =>
  api
    .post<ICreateXeroConnectionResponse, ICreateXeroConnectionRequest>(
      'api/v1/xero/connections',
      requestBody
    )
    .then((response) => response)
    .catch(handleApiError);

export const createXeroTenantConnection = async ({
  connectionId,
  tenantId
}: {
  connectionId: string;
  tenantId: string;
}) =>
  api
    .post<ICreateXeroTenantConnectionResponse, null>(
      `api/v1/xero/connections/${connectionId}/tenants/${tenantId}/connect`,
      null
    )
    .then((response) => response)
    .catch(handleApiError);

export const getXeroTenants = async (xeroConnectionId: string) =>
  api
    .get<IGetXeroTenantResponse[]>(`api/v1/xero/connections/${xeroConnectionId}/tenants`)
    .then((response) => response)
    .catch(handleApiError);

const XERO_FEED_ALREADY_EXISTS = '4068';
export const getTenant = async () =>
  api
    .get<IGetTenantByAccountIdResponse>(`api/v1/xero/connections/tenants`)
    .then((response) => response)
    .catch(handleApiError);

export const disconnectTenant = async (tenantId: string) =>
  api
    .post(`api/v1/xero/connections/tenants/${tenantId}/disconnect`, null)
    .then((response) => response)
    .catch(handleApiError);

export const createTenantFeed = async (tenantId: string, body: ICreateXeroFeedRequest) =>
  api
    .post<IXeroTenantFeedResponse, ICreateXeroFeedRequest>(
      `api/v1/xero/connections/tenants/${tenantId}/feeds`,
      body
    )
    .then((response) => response)
    /* eslint-disable @typescript-eslint/no-explicit-any */
    .catch(async (responseError: any) => {
      const errorResponse = await responseError.then((res: any) => {
        if (res.code === XERO_FEED_ALREADY_EXISTS) {
          return { isError: false, ...res };
        }

        return { isError: true, ...res };
      });

      if (errorResponse.isError) {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        const { isError, ...errorDetails } = errorResponse;
        throw new Error(errorDetails);
      }

      return { data: null };
    });

export const getTenantFeeds = async (tenantId: string) =>
  api
    .get<IXeroTenantFeedResponse[]>(`api/v1/xero/connections/tenants/${tenantId}/feeds`)
    .then((response) => response)
    .catch(handleApiError);

export const disconnectTenantFeed = async (tenantId: string, feedId: string) =>
  api
    .patch<IXeroTenantFeedResponse, null>(
      `api/v1/xero/connections/tenants/${tenantId}/feeds/${feedId}`,
      null
    )
    .then((response) => response)
    .catch(handleApiError);
